import React from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./BrokerItem.css";


const BrokersItem = ({ broker, onClick }) => {
  return (
    <>
     <div className="broker-item" onClick={() => onClick(broker)}>
      <div className="broker-content">
        <div className="broker-logo-wrapper">
          <img
            src={broker.logo}
            alt={broker.name}
            className="broker-logo"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />

          {/* <div className="broker-logo-fallback">
            {broker.displayName?.charAt(0)?.toUpperCase()}
          </div> */}
        </div>

      </div>

      <ArrowForwardIosIcon className="broker-arrow" />
    </div>
    </>
  );
};

export default BrokersItem;
